import api from '../config/axios'; // Assuming your configured axios instance is here
import { logger } from '../utils/logger'; // We'll create this next

const handleResponse = (response) => {
  logger.debug('[ApiService] Response data:', response.data);
  return response.data;
};

const handleError = (error) => {
  logger.error('[ApiService] API call failed:', error.response || error.message);
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    throw error.response.data || { message: error.response.statusText || 'An error occurred' };
  } else if (error.request) {
    // The request was made but no response was received
    throw { message: 'No response from server. Check network connection.' };
  } else {
    // Something happened in setting up the request that triggered an Error
    throw { message: error.message || 'An unknown error occurred' };
  }
};

export const apiService = {
  get: (url, config) => api.get(url, config).then(handleResponse).catch(handleError),
  post: (url, data, config) => api.post(url, data, config).then(handleResponse).catch(handleError),
  put: (url, data, config) => api.put(url, data, config).then(handleResponse).catch(handleError),
  delete: (url, config) => api.delete(url, config).then(handleResponse).catch(handleError),
  // Add other methods like patch if needed
};

// If you prefer a default export:
// export default apiService;